import React from 'react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { fontSizes } from 'styles/abstracts/typography';
import { LEVEL } from '../../../../Routes/GlobalExperience/Reporting/_Containers/configs/settingOptions';
import { MenuItemLabel } from '../../../../Routes/Insights/InsightsWall/_Containers/InsightWallGrid/_Components/InsightModeMenu/_Components/InsightModeMenuOption';
import { CheckboxContainer, RadioButton } from '../CLineChartSettings';

const TitleSection = styled.p`
  font-size: ${fontSizes.bigger};
  margin-bottom: 0.5em;
`;

class LevelDisplaySettings extends React.Component {
  levelCheckboxClicked = level => {
    const { onSettingsChange, settings } = this.props;
    onSettingsChange({ ...settings, level });
  };

  render() {
    const { settings, t } = this.props;
    const { level } = settings;

    return (
      <div>
        <br />
        <TitleSection>{t('card:Depth level')}</TitleSection>
        {Object.keys(LEVEL).map(option => (
          <>
            <CheckboxContainer>
              <MenuItemLabel checked={level === LEVEL[option].id}>
                <RadioButton
                  type="radio"
                  checked={level === LEVEL[option].id}
                  onChange={() => this.levelCheckboxClicked(LEVEL[option].id)}
                  value={LEVEL[option].id}
                />
              </MenuItemLabel>
              {t(LEVEL[option].label)}
            </CheckboxContainer>
            <br />
          </>
        ))}
      </div>
    );
  }
}

export default withTranslation('button', ['card'])(LevelDisplaySettings);
